import React from 'react';

const formatUsd = (value) => {
  if (!Number.isFinite(value)) return '—';
  return `$${value.toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
};

const formatAmount = (value) => {
  if (!Number.isFinite(value)) return '—';
  return value.toLocaleString(undefined, { maximumFractionDigits: 6 });
};

function BucketLabel({ bucket }) {
  const map = {
    wallet: 'Wallet',
    aave: 'Aave',
    lido: 'Lido',
    belts: 'Belts',
  };
  return map[bucket] || bucket;
}

export default function PortfolioDetailsTable({ positions, unpriced }) {
  const pricedPositions = positions.filter((pos) => pos.priced);

  return (
    <div className="card">
      <div className="muted small" style={{ marginBottom: '0.5rem' }}>Position Details</div>
      <div style={{ overflowX: 'auto' }}>
        <table className="table" style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Label</th>
              <th>Chain</th>
              <th>Bucket</th>
              <th style={{ textAlign: 'right' }}>Amount</th>
              <th style={{ textAlign: 'right' }}>USD</th>
            </tr>
          </thead>
          <tbody>
            {pricedPositions.length === 0 ? (
              <tr><td colSpan="5" className="muted small">No priced positions yet.</td></tr>
            ) : (
              pricedPositions.map((pos) => (
                <tr key={pos.id}>
                  <td>{pos.label}</td>
                  <td>{pos.chain}</td>
                  <td><BucketLabel bucket={pos.bucket} /></td>
                  <td style={{ textAlign: 'right' }}>{formatAmount(pos.underlyingAmount)} {pos.underlyingSymbol}</td>
                  <td style={{ textAlign: 'right' }}>{formatUsd(pos.usdValue)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {unpriced.length ? (
        <details style={{ marginTop: '0.75rem' }}>
          <summary className="muted small">Unpriced positions</summary>
          <div style={{ overflowX: 'auto', marginTop: '0.5rem' }}>
            <table className="table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Label</th>
                  <th>Chain</th>
                  <th>Bucket</th>
                  <th style={{ textAlign: 'right' }}>Amount</th>
                  <th style={{ textAlign: 'right' }}>USD</th>
                </tr>
              </thead>
              <tbody>
                {unpriced.map((pos) => (
                  <tr key={pos.id}>
                    <td>{pos.label}</td>
                    <td>{pos.chain}</td>
                    <td><BucketLabel bucket={pos.bucket} /></td>
                    <td style={{ textAlign: 'right' }}>{formatAmount(pos.underlyingAmount)} {pos.underlyingSymbol}</td>
                    <td style={{ textAlign: 'right' }}>Unpriced</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </details>
      ) : null}
    </div>
  );
}
